import { Component, Input, Output, EventEmitter, ElementRef, ViewChild, ChangeDetectorRef, effect, OnInit } from '@angular/core';
import { PatientSessionService } from '../patient-session.service';
import { PatientTargetDataModel, PatientTargetModel, PatientTargetStatus, PromptCodeModel, PromptScheduleModel, TargetType } from '../../../core/api/models';
import { BaseBoxComponent } from '../base-box/base-box.component';
import { PatientTargetForChainModel } from '../../../shared/models/models';
@Component({
  selector: 'app-box-grouped',
  templateUrl: './box-grouped.component.html',
  standalone: false,
})
export class BoxGroupedComponent extends BaseBoxComponent implements OnInit {
  @Input() subTargetsDictionary: { [key: number]: PatientTargetForChainModel[] } = {};
  @Input() subTargets: PatientTargetForChainModel[] = [];
  @Input() isBottomBox: boolean = false;
  @Input() isTopBox: boolean = true;
  text: string | null | undefined = '-';
  targetID: number = 0;
  @Input() isChain: boolean = false;
  isBackwards: boolean = false;
  @Input() promptSchedules: PromptScheduleModel[] = [];
  @Input() target: PatientTargetModel | undefined = undefined;
  hideBox: boolean = false;
  @Input() allPromptCodes: PromptCodeModel[] = [];
  @Input() isPreview?: boolean;
  constructor(
    protected override cdRef: ChangeDetectorRef,
    private patientSessionService: PatientSessionService) {
    super(cdRef);
  }

  ngOnInit(): void {
    
    this.text = this.target?.TargetName ?? '-';
    this.targetID = this.target?.ID ?? 0;
    this.isBackwards = this.target?.IsBackward ?? false;

    console.info(`Box Grouped #${this.targetID} ${this.text}`, this.subTargets);

    //remove subtargets that are of a type that has subtargets
    this.subTargets = this.subTargets.filter(target => target.TargetType != TargetType.ConditionalDiscrimination && target.TargetType != TargetType.GroupedFrequency && target.TargetType != TargetType.TaskAnalysis);


    if (this.isChain) {

      if (this.target?.OpenSubTargets) {
        this.subTargets.forEach(target => {
          target.Enabled = true;
        });
      } else {
        //Change subtargets  to have the enabled flag true only if it is the first target or if the previous one is mastered. Make this inverse if the chain isBackwards
        this.subTargets && this.subTargets.forEach((target, index) => {
          if (this.isBackwards) {
            target.Enabled = target.ForceOpen || (index === this.subTargets.length - 1 || this.subTargets[index + 1].TargetStatus === PatientTargetStatus.Mastered || this.subTargets[index + 1].TargetStatus === PatientTargetStatus.Fluent);
          } else {
            target.Enabled = target.ForceOpen || (index === 0 || this.subTargets[index - 1].TargetStatus === PatientTargetStatus.Mastered || this.subTargets[index - 1].TargetStatus === PatientTargetStatus.Fluent);
          }
        });
      }
    } else{
      this.subTargets.forEach(target => {
        target.Enabled = true;
      });
    }

    
    //If there are no sub targets, hide the box
    this.hideBox = !this.subTargets || this.subTargets.length === 0;
  }

}
